import { useState, useEffect } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const addHomeStats = ApiEndpoints.stats.create;
const getHomeStats = ApiEndpoints.stats.edit;
const updateHomeStats = ApiEndpoints.stats.update;

export default function Stats() {

  const [stats, setStats] = useState({
    count1: "",
    description1: "",
    count2: "",
    description2: "",
    count3: "",
    description3: "",
    count4: "",
    description4: "",
    count5: "",
    description5: "",
    count6: "",
    description6: "",
  });

  const fetchData = async () => {
    try {
      const response = await ApiRequest("GET", getHomeStats,);
      if (response && response.Home_our_stat) {
        setStats(response.Home_our_stat);
      }
    } catch (error) {
      console.error("Error fetching blog data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target;
    setStats((prevStats) => ({
      ...prevStats,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stats.count1 || !stats.description1 || !stats.count2 || !stats.description2 || !stats.count3 || !stats.description3 || !stats.count4 || !stats.description4 || !stats.count5 || !stats.description5 || !stats.count6 || !stats.description6) {
      toast.error("All the fields of stats are required.");
      return;
    }

    try {
      const endpoint = stats._id ? updateHomeStats : addHomeStats;
      const response = await ApiRequest("POST", endpoint, stats);

      if (response.error === false) {
        toast.success(response.message);
        fetchData();
      } else {
        toast.error("Failed to save stats. Please try again.");
      }
    } catch (error) {
      console.error("Error saving stats:", error);
    }
  };

  const pagename = {
    name: 'Stats Management',
    user: 'Admin',
    innerpage: 'Stats Management / Our Stats'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-content-page">
        <form onSubmit={handleSubmit}>
          <div className="add-content-wrap">
            <div className="row">
              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Number 1<small>*</small></label>
                    {/* <span>Numeric</span> */}
                  </div>
                  <input type="text" className="form-control" placeholder="Ex: 500 k+" name="count1" value={stats.count1} onChange={handleChange} />
                </div>

                <div className="add-page-inputs case-metrix-wrap">
                  <div className="label-wrap-add">
                    <label>Description 1<small>*</small></label>
                  </div>
                  <textarea placeholder="Description Here" className="form-control" name="description1" value={stats.description1} onChange={handleChange} />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Number 2<small>*</small></label>
                  </div>
                  <input type="text" className="form-control" placeholder="Enter Here" name="count2" value={stats.count2} onChange={handleChange} />
                </div>

                <div className="add-page-inputs case-metrix-wrap">
                  <div className="label-wrap-add">
                    <label>Description 2<small>*</small></label>
                  </div>
                  <textarea placeholder="Description Here" className="form-control" name="description2" value={stats.description2} onChange={handleChange} />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Number 3<small>*</small></label>
                  </div>
                  <input type="text" className="form-control" placeholder="Enter Here" name="count3" value={stats.count3} onChange={handleChange} />
                </div>

                <div className="add-page-inputs case-metrix-wrap">
                  <div className="label-wrap-add">
                    <label>Description 3<small>*</small></label>
                  </div>
                  <textarea placeholder="Description Here" className="form-control" name="description3" value={stats.description3} onChange={handleChange} />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Number 4<small>*</small></label>
                  </div>
                  <input type="text" className="form-control" placeholder="Enter Here" name="count4" value={stats.count4} onChange={handleChange} />
                </div>

                <div className="add-page-inputs case-metrix-wrap">
                  <div className="label-wrap-add">
                    <label>Description 4<small>*</small></label>
                  </div>
                  <textarea placeholder="Description Here" className="form-control" name="description4" value={stats.description4} onChange={handleChange} />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Number 5<small>*</small></label>
                  </div>
                  <input type="text" className="form-control" placeholder="Enter Here" name="count5" value={stats.count5} onChange={handleChange} />
                </div>

                <div className="add-page-inputs case-metrix-wrap">
                  <div className="label-wrap-add">
                    <label>Description 5<small>*</small></label>
                  </div>
                  <textarea placeholder="Description Here" className="form-control" name="description5" value={stats.description5} onChange={handleChange} />
                </div>
              </div>

              <div className="col-lg-4">
                <div className="add-page-inputs">
                  <div className="label-wrap-add">
                    <label>Number 6<small>*</small></label>
                  </div>
                  <input type="text" className="form-control" placeholder="Enter Here" name="count6" value={stats.count6} onChange={handleChange} />
                </div>

                <div className="add-page-inputs case-metrix-wrap">
                  <div className="label-wrap-add">
                    <label>Description 6<small>*</small></label>
                  </div>
                  <textarea placeholder="Description Here" className="form-control" name="description6" value={stats.description6} onChange={handleChange} />
                </div>
              </div>


              <div className="col-lg-12">
                <div className="btn-group-home-solve">
                  <button type="submit" className="default-btn">save <span></span></button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}
